import { graphql } from '~publish/graphql'

export const SavedViewFields = graphql(/* GraphQL */ `
  fragment SavedViewFields on SavedView @_unmask {
    id
    name
    section
    view
    filters
    icon
    color
    createdAt
    updatedAt
  }
`)
